// extracted by mini-css-extract-plugin
export default {"infoIcon":"InfoIcon_infoIcon__qQsWA"};